import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Helpers from 'infosite/helpers';
import CloseIcon from 'grommet/components/icons/base/Close';
const img = document.createElement('img');
const hasObjectFit = img.style.hasOwnProperty('objectFit');

export default class CloseButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {}
  }
  componentDidMount(){
    //let $this = $(ReactDOM.findDOMNode(this));
  }
  componentWillUpdate(nextProps,nextState){
  }


  render() {
      return (
          <button className="close-button" onClick={this.props.onClick}>
            <CloseIcon />
          </button>
      )
  } // render

}

CloseButton.propTypes={
  "onClick": React.PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-layer/close-button.jsx